import { NoteBlock } from "../block";

export interface ChartBlock extends NoteBlock {
  "chart-id": string;
}

export function isChartBlock(block: NoteBlock): block is ChartBlock {
  return (block as ChartBlock)["chart-id"] !== undefined;
}
